import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { AppLayout } from "../../components/layout/Header";
import { useAuth } from "../../js/hooks/useAuth";
import { manualsUrl, JOURNEY_LINK_PROPS } from "../../js/utils/siteLinks";

export default function ManualRedirect() {
  const { role: pathRole } = useParams();
  const { role, session } = useAuth();
  const dest = manualsUrl(pathRole || role, session);

  useEffect(() => {
    window.open(dest, "_blank", "noopener,noreferrer");
  }, [dest]);

  return (
    <AppLayout>
      <article className="page-header">
        <h1>User manuals</h1>
        <p className="page-lead">
          Role manuals live on DreamHomeJourney, behind a sign-in. Opening your book in a new tab now.
        </p>
        <p>
          <a className="primary-btn" href={dest} {...JOURNEY_LINK_PROPS}>
            Continue to the manual
          </a>
        </p>
      </article>
    </AppLayout>
  );
}
